@use '@helsenorge/designsystem-react/scss/spacers' as spacers;

.melde-feil {
  &__submit-button {
    margin-right: spacers.$spacer;
  }
}
